import { shallowEqual, useSelector } from 'react-redux'


export const useDomainProjectName = () => {
  const projectName = useSelector((state: any) => state.dealer.project_name, shallowEqual)
  return projectName
}
